// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'persons-group';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.688 4.5a1.687 1.687 0 1 0 3.374 0 1.687 1.687 0 0 0-3.375 0zm1.687 2.813a2.813 2.813 0 0 0-2.813 2.812v1.688h1.125l.563 4.5H4.5M12.938 4.5a1.687 1.687 0 1 0 3.374 0 1.687 1.687 0 0 0-3.375 0zm1.687 2.813a2.812 2.812 0 0 1 2.813 2.812v1.688h-1.125l-.563 4.5H13.5m-6.75-13.5a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0zm6.188 7.312a3.937 3.937 0 1 0-7.876 0v1.688H6.75l.563 5.624h3.375l.562-5.625h1.688z'
  />
);

export const viewBox = '0 0 18 18';
